/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * jelled services
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from 'react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from 'react-query'
import type {
  SignOut200,
  SignOutParams,
  LoginResponse,
  AuthByProviderParams,
  AuthByProviderCallbackParams,
  AuthCallbackWithProviderParams,
  EmailValidation,
  ValidateEmail,
  AuthForgetPasswordBody,
  AuthValidateResetPasswordLinkParams,
  ResetPassword,
  AuthVerifyUserParams,
  UserNew,
  LoginEmailPassword,
  Failure,
  AuthSsoParams,
  AnonymousUser,
  AnonymousUserNew,
  Twin,
  WaitlistEntry,
  WaitlistEntryNew,
  OauthSlackParams,
  OauthSlackInstallParams,
  OauthGoogle,
  OauthGoogleParams
} from '../auth'

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


/**
 * Logout

 */
export const signOut = (
    params: SignOutParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SignOut200>> => {
    return axios.get(
      `/api/v1/sign-out`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSignOutQueryKey = (params: SignOutParams,) => [`/api/v1/sign-out`, ...(params ? [params]: [])];

    
export type SignOutQueryResult = NonNullable<Awaited<ReturnType<typeof signOut>>>
export type SignOutQueryError = AxiosError<unknown>

export const useSignOut = <TData = Awaited<ReturnType<typeof signOut>>, TError = AxiosError<unknown>>(
 params: SignOutParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof signOut>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSignOutQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof signOut>>> = ({ signal }) => signOut(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof signOut>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const renderAuthPage = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.get(
      `/api/auth-test`,options
    );
  }


export const getRenderAuthPageQueryKey = () => [`/api/auth-test`];

    
export type RenderAuthPageQueryResult = NonNullable<Awaited<ReturnType<typeof renderAuthPage>>>
export type RenderAuthPageQueryError = AxiosError<unknown>

export const useRenderAuthPage = <TData = Awaited<ReturnType<typeof renderAuthPage>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof renderAuthPage>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getRenderAuthPageQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof renderAuthPage>>> = ({ signal }) => renderAuthPage({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof renderAuthPage>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const authByProvider = (
    params: AuthByProviderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.get(
      `/api/auth`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getAuthByProviderQueryKey = (params: AuthByProviderParams,) => [`/api/auth`, ...(params ? [params]: [])];

    
export type AuthByProviderQueryResult = NonNullable<Awaited<ReturnType<typeof authByProvider>>>
export type AuthByProviderQueryError = AxiosError<unknown>

export const useAuthByProvider = <TData = Awaited<ReturnType<typeof authByProvider>>, TError = AxiosError<unknown>>(
 params: AuthByProviderParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authByProvider>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthByProviderQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authByProvider>>> = ({ signal }) => authByProvider(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof authByProvider>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const authByProviderCallback = (
    params: AuthByProviderCallbackParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.get(
      `/api/auth/callback`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getAuthByProviderCallbackQueryKey = (params: AuthByProviderCallbackParams,) => [`/api/auth/callback`, ...(params ? [params]: [])];

    
export type AuthByProviderCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof authByProviderCallback>>>
export type AuthByProviderCallbackQueryError = AxiosError<unknown>

export const useAuthByProviderCallback = <TData = Awaited<ReturnType<typeof authByProviderCallback>>, TError = AxiosError<unknown>>(
 params: AuthByProviderCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authByProviderCallback>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthByProviderCallbackQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authByProviderCallback>>> = ({ signal }) => authByProviderCallback(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof authByProviderCallback>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const authCallbackWithProvider = (
    provider: 'auth0' | 'azureadv2' | 'google',
    params?: AuthCallbackWithProviderParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.get(
      `/api/auth/callback/${provider}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getAuthCallbackWithProviderQueryKey = (provider: 'auth0' | 'azureadv2' | 'google',
    params?: AuthCallbackWithProviderParams,) => [`/api/auth/callback/${provider}`, ...(params ? [params]: [])];

    
export type AuthCallbackWithProviderQueryResult = NonNullable<Awaited<ReturnType<typeof authCallbackWithProvider>>>
export type AuthCallbackWithProviderQueryError = AxiosError<unknown>

export const useAuthCallbackWithProvider = <TData = Awaited<ReturnType<typeof authCallbackWithProvider>>, TError = AxiosError<unknown>>(
 provider: 'auth0' | 'azureadv2' | 'google',
    params?: AuthCallbackWithProviderParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authCallbackWithProvider>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthCallbackWithProviderQueryKey(provider,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authCallbackWithProvider>>> = ({ signal }) => authCallbackWithProvider(provider,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof authCallbackWithProvider>>, TError, TData>(queryKey, queryFn, {enabled: !!(provider), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * validate email
 * @summary validate email
 */
export const authValidateEmail = (
    validateEmail: ValidateEmail, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<EmailValidation>> => {
    return axios.post(
      `/api/auth/validate-email`,
      validateEmail,options
    );
  }



    export type AuthValidateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof authValidateEmail>>>
    export type AuthValidateEmailMutationBody = ValidateEmail
    export type AuthValidateEmailMutationError = AxiosError<unknown>

    export const useAuthValidateEmail = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authValidateEmail>>, TError,{data: ValidateEmail}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authValidateEmail>>, {data: ValidateEmail}> = (props) => {
          const {data} = props ?? {};

          return  authValidateEmail(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof authValidateEmail>>, TError, {data: ValidateEmail}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * generate forget password email
 * @summary generate forget password email
 */
export const authForgetPassword = (
    authForgetPasswordBody: AuthForgetPasswordBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/auth/forget-password`,
      authForgetPasswordBody,options
    );
  }



    export type AuthForgetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authForgetPassword>>>
    export type AuthForgetPasswordMutationBody = AuthForgetPasswordBody
    export type AuthForgetPasswordMutationError = AxiosError<unknown>

    export const useAuthForgetPassword = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authForgetPassword>>, TError,{data: AuthForgetPasswordBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authForgetPassword>>, {data: AuthForgetPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  authForgetPassword(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof authForgetPassword>>, TError, {data: AuthForgetPasswordBody}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * reset password based on one time passcode
 * @summary reset password based on one time passcode
 */
export const authValidateResetPasswordLink = (
    params: AuthValidateResetPasswordLinkParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/api/auth/reset-password`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getAuthValidateResetPasswordLinkQueryKey = (params: AuthValidateResetPasswordLinkParams,) => [`/api/auth/reset-password`, ...(params ? [params]: [])];

    
export type AuthValidateResetPasswordLinkQueryResult = NonNullable<Awaited<ReturnType<typeof authValidateResetPasswordLink>>>
export type AuthValidateResetPasswordLinkQueryError = AxiosError<unknown>

export const useAuthValidateResetPasswordLink = <TData = Awaited<ReturnType<typeof authValidateResetPasswordLink>>, TError = AxiosError<unknown>>(
 params: AuthValidateResetPasswordLinkParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authValidateResetPasswordLink>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthValidateResetPasswordLinkQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authValidateResetPasswordLink>>> = ({ signal }) => authValidateResetPasswordLink(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof authValidateResetPasswordLink>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * reset password based on one time passcode
 * @summary reset password based on one time passcode
 */
export const authResetPassword = (
    resetPassword: ResetPassword, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.post(
      `/api/auth/reset-password`,
      resetPassword,options
    );
  }



    export type AuthResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authResetPassword>>>
    export type AuthResetPasswordMutationBody = ResetPassword
    export type AuthResetPasswordMutationError = AxiosError<unknown>

    export const useAuthResetPassword = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResetPassword>>, TError,{data: ResetPassword}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authResetPassword>>, {data: ResetPassword}> = (props) => {
          const {data} = props ?? {};

          return  authResetPassword(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof authResetPassword>>, TError, {data: ResetPassword}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * verify account based on one time passcode
 * @summary verify account based on one time passcode
 */
export const authVerifyUser = (
    params: AuthVerifyUserParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/api/auth/verify-user`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getAuthVerifyUserQueryKey = (params: AuthVerifyUserParams,) => [`/api/auth/verify-user`, ...(params ? [params]: [])];

    
export type AuthVerifyUserQueryResult = NonNullable<Awaited<ReturnType<typeof authVerifyUser>>>
export type AuthVerifyUserQueryError = AxiosError<unknown>

export const useAuthVerifyUser = <TData = Awaited<ReturnType<typeof authVerifyUser>>, TError = AxiosError<unknown>>(
 params: AuthVerifyUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authVerifyUser>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthVerifyUserQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authVerifyUser>>> = ({ signal }) => authVerifyUser(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof authVerifyUser>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * register as an user with email and password, a confirmation email will be sent to the supplied email address.

 * @summary register as an user with email and password
 */
export const authRegister = (
    userNew: UserNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/api/auth/register`,
      userNew,options
    );
  }



    export type AuthRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof authRegister>>>
    export type AuthRegisterMutationBody = UserNew
    export type AuthRegisterMutationError = AxiosError<unknown>

    export const useAuthRegister = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRegister>>, TError,{data: UserNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRegister>>, {data: UserNew}> = (props) => {
          const {data} = props ?? {};

          return  authRegister(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof authRegister>>, TError, {data: UserNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * login as email and password
 * @summary login as email and password
 */
export const authLogin = (
    loginEmailPassword: LoginEmailPassword, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.post(
      `/api/auth/login`,
      loginEmailPassword,options
    );
  }



    export type AuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>
    export type AuthLoginMutationBody = LoginEmailPassword
    export type AuthLoginMutationError = AxiosError<unknown>

    export const useAuthLogin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,{data: LoginEmailPassword}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogin>>, {data: LoginEmailPassword}> = (props) => {
          const {data} = props ?? {};

          return  authLogin(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof authLogin>>, TError, {data: LoginEmailPassword}, TContext>(mutationFn, mutationOptions)
    }
    
export const authSso = (
    params: AuthSsoParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.get(
      `/api/sso`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getAuthSsoQueryKey = (params: AuthSsoParams,) => [`/api/sso`, ...(params ? [params]: [])];

    
export type AuthSsoQueryResult = NonNullable<Awaited<ReturnType<typeof authSso>>>
export type AuthSsoQueryError = AxiosError<Failure>

export const useAuthSso = <TData = Awaited<ReturnType<typeof authSso>>, TError = AxiosError<Failure>>(
 params: AuthSsoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authSso>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthSsoQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authSso>>> = ({ signal }) => authSso(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof authSso>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Create or update anonymous user
 * @summary Create or update anonymous user
 */
export const usersCreateAnonymous = (
    anonymousUserNew: AnonymousUserNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AnonymousUser>> => {
    return axios.post(
      `/api/auth/anonymous`,
      anonymousUserNew,options
    );
  }



    export type UsersCreateAnonymousMutationResult = NonNullable<Awaited<ReturnType<typeof usersCreateAnonymous>>>
    export type UsersCreateAnonymousMutationBody = AnonymousUserNew
    export type UsersCreateAnonymousMutationError = AxiosError<unknown>

    export const useUsersCreateAnonymous = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersCreateAnonymous>>, TError,{data: AnonymousUserNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersCreateAnonymous>>, {data: AnonymousUserNew}> = (props) => {
          const {data} = props ?? {};

          return  usersCreateAnonymous(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersCreateAnonymous>>, TError, {data: AnonymousUserNew}, TContext>(mutationFn, mutationOptions)
    }
    
/**
 * Returns a twin by short_url
 * @summary Returns a twin by short_url
 */
export const twinsGetSharedTwin = (
    shortUrl: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Twin>> => {
    return axios.get(
      `/api/auth/shared/${shortUrl}`,options
    );
  }


export const getTwinsGetSharedTwinQueryKey = (shortUrl: string,) => [`/api/auth/shared/${shortUrl}`];

    
export type TwinsGetSharedTwinQueryResult = NonNullable<Awaited<ReturnType<typeof twinsGetSharedTwin>>>
export type TwinsGetSharedTwinQueryError = AxiosError<void | Failure>

export const useTwinsGetSharedTwin = <TData = Awaited<ReturnType<typeof twinsGetSharedTwin>>, TError = AxiosError<void | Failure>>(
 shortUrl: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof twinsGetSharedTwin>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTwinsGetSharedTwinQueryKey(shortUrl);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof twinsGetSharedTwin>>> = ({ signal }) => twinsGetSharedTwin(shortUrl, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof twinsGetSharedTwin>>, TError, TData>(queryKey, queryFn, {enabled: !!(shortUrl), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


/**
 * Create or update waitlist entry (anonymous user)
 * @summary Create or update waitlist entry
 */
export const usersCreateWaitlistEntry = (
    waitlistEntryNew: WaitlistEntryNew, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<WaitlistEntry>> => {
    return axios.post(
      `/api/auth/waitlist`,
      waitlistEntryNew,options
    );
  }



    export type UsersCreateWaitlistEntryMutationResult = NonNullable<Awaited<ReturnType<typeof usersCreateWaitlistEntry>>>
    export type UsersCreateWaitlistEntryMutationBody = WaitlistEntryNew
    export type UsersCreateWaitlistEntryMutationError = AxiosError<unknown>

    export const useUsersCreateWaitlistEntry = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersCreateWaitlistEntry>>, TError,{data: WaitlistEntryNew}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersCreateWaitlistEntry>>, {data: WaitlistEntryNew}> = (props) => {
          const {data} = props ?? {};

          return  usersCreateWaitlistEntry(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof usersCreateWaitlistEntry>>, TError, {data: WaitlistEntryNew}, TContext>(mutationFn, mutationOptions)
    }
    
export const oauthSlack = (
    params: OauthSlackParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.get(
      `/api/auth/oauth/slack`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getOauthSlackQueryKey = (params: OauthSlackParams,) => [`/api/auth/oauth/slack`, ...(params ? [params]: [])];

    
export type OauthSlackQueryResult = NonNullable<Awaited<ReturnType<typeof oauthSlack>>>
export type OauthSlackQueryError = AxiosError<unknown>

export const useOauthSlack = <TData = Awaited<ReturnType<typeof oauthSlack>>, TError = AxiosError<unknown>>(
 params: OauthSlackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof oauthSlack>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOauthSlackQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof oauthSlack>>> = ({ signal }) => oauthSlack(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof oauthSlack>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const oauthSlackInstall = (
    params: OauthSlackInstallParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    return axios.get(
      `/api/auth/oauth/slack-install`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getOauthSlackInstallQueryKey = (params: OauthSlackInstallParams,) => [`/api/auth/oauth/slack-install`, ...(params ? [params]: [])];

    
export type OauthSlackInstallQueryResult = NonNullable<Awaited<ReturnType<typeof oauthSlackInstall>>>
export type OauthSlackInstallQueryError = AxiosError<void>

export const useOauthSlackInstall = <TData = Awaited<ReturnType<typeof oauthSlackInstall>>, TError = AxiosError<void>>(
 params: OauthSlackInstallParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof oauthSlackInstall>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOauthSlackInstallQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof oauthSlackInstall>>> = ({ signal }) => oauthSlackInstall(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof oauthSlackInstall>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}


export const oauthGoogle = (
    oauthGoogle: OauthGoogle,
    params?: OauthGoogleParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LoginResponse>> => {
    return axios.post(
      `/api/auth/oauth/google`,
      oauthGoogle,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



    export type OauthGoogleMutationResult = NonNullable<Awaited<ReturnType<typeof oauthGoogle>>>
    export type OauthGoogleMutationBody = OauthGoogle
    export type OauthGoogleMutationError = AxiosError<unknown>

    export const useOauthGoogle = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof oauthGoogle>>, TError,{data: OauthGoogle;params?: OauthGoogleParams}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof oauthGoogle>>, {data: OauthGoogle;params?: OauthGoogleParams}> = (props) => {
          const {data,params} = props ?? {};

          return  oauthGoogle(data,params,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof oauthGoogle>>, TError, {data: OauthGoogle;params?: OauthGoogleParams}, TContext>(mutationFn, mutationOptions)
    }
    
